// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59ad06d7","455":"d5c08ef8","977":"06a17bf7"}[chunkId] + ".chunk.js";
};